import React, { Component } from 'react';

import Aux from '../Aux/Aux';
import classes from './Layout.module.css';

export interface LayoutProps {}
export interface LayoutState { showSideDrawer: boolean }

class Layout extends Component<LayoutProps, LayoutState> {
    state = {
        showSideDrawer: false
    }

    sideDrawerClosedHandler = () => {
        this.setState( { showSideDrawer: false } );
    }

    sideDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showSideDrawer: !prevState.showSideDrawer };
        } );
    }

    /*
    <div className={ribbonClasses}>
        <div className="banner">
            <div className="text">
                <div className={classes.RibbonText}>
                    25th Anniversary
                </div>
            </div>
        </div>
    </div>
    */

    render () {
        // let ribbonClasses = "ribbon ribbon-red ribbon-large " + classes.Ribbon;
        // let ribbonTextClasses = "banner " + classes.RibbonText;
        return (
            <Aux>
                <main className={classes.Content}>

                    {this.props.children}
                </main>
            </Aux>
        )
    }
}

export default Layout;
